import React from 'react';
import { getContext } from 'common';
import Styled from './styles';

export interface AppBannerContentProps {
  /** Content goes here. Content will be right aligned. */
  children: React.ReactNode;
}

/** Place banner (right-aligned) content here. For example: <Notifications/>, <TenantSwitch/>. */
const AppBannerContent: React.FC<AppBannerContentProps> = React.forwardRef<HTMLElement, AppBannerContentProps>((props: AppBannerContentProps, ref) =>
  getContext(({ RTL }: { RTL: boolean }) => {
    const {
      children,
      ...otherProps
    } = props;
    return (
      <Styled.AppBannerContent ref={ref} $rtl={RTL} {...otherProps}>
        {children}
      </Styled.AppBannerContent>
    );
  }));

AppBannerContent.displayName = 'AppBannerContent';

export default AppBannerContent;
